import React, { Component } from 'react';
import InlineField from './InlineField';

import Message from './ValidationMessage';

export class CheckBoxField extends Component {
  render() {
    let { intl, translation, fieldId, input, required, label, disabled, displayType,checked, meta: { touched, error, warning } } = this.props;
    let showError = touched && error ? "error" : "";

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    const isChecked = (checked !== undefined) ? checked : input.checked;

    if ( displayType === 'inline' ) {      
      return <InlineField fieldType='renderCheckBox' content={ input.value } label={label} />;
    }

    return (
      <div className={`${required && 'required'} field ${showError}`}>
        <div id={fieldId} className="ui checkbox">
          <input {...input} type="checkbox" disabled={disabled} checked={isChecked}/>
          <label>{label}</label>
        </div>
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }

}
